import React from "react";
import "./TeamDashboardCompositionLoader.scss";

const TeamDashboardCompositionLoader = () => {
  return (
    <div className="team-dashboard-composition-container">
    <div className="carousel-skeleton-container">
    <div className="carousel-skeleton-card-container">
      <div className="skeleton-card-image skeleton"></div>
    </div>
  </div>
  </div>
  );
};

export default TeamDashboardCompositionLoader;
